import React from 'react'
import {
	AlertsBaseDrawer,
	AlertsComparator,
	AlertsComparatorUnit,
	AlertsComparatorValue,
	AlertsComparisonType,
	AlertsConditionName,
	AlertsDrawerBaseFooter,
	AlertsMoreFeatures,
	AlertsProviders,
	AlertsSitesRequired
} from "Pages/ReportsAlerts/Alerts/Conditions/@components"
import { Divider, Grid } from "@mui/material"


import { BACKEND_APIS } from "@constants"


export default function PriceChangeDrawer({ onSubmitAlert, isLoading }) {

	return <AlertsBaseDrawer
		footer={<AlertsDrawerBaseFooter onSubmitAlert={onSubmitAlert} isLoading={isLoading} />}
		content={<Grid container spacing={3}>
			<Grid item xs={12} data-tour-id="cond-pch-name">
				<AlertsConditionName/>
			</Grid>
			<Grid item xs={12}>
				<Divider sx={{ my: 1 }}/>
			</Grid>
			<Grid item xs={12} data-tour-id="cond-pch-sites">
				<AlertsSitesRequired/>
			</Grid>
			<Grid item xs={12}>
				<Divider sx={{ my: 1 }}/>
			</Grid>
			<Grid item xs={12} data-tour-id="cond-pch-providers">
				<AlertsProviders/>
			</Grid>
			<Grid item xs={12}>
				<Divider sx={{ my: 1 }}/>
			</Grid>
			<Grid item xs={4} data-tour-id="cond-pch-comparator">
				<AlertsComparator
					urlAjax={`${BACKEND_APIS.MASTER_DATA}/all/options/comparator_changes`}
				/>
			</Grid>
			<Grid item xs={4} data-tour-id="cond-pch-comp-value">
				<AlertsComparatorValue/>
			</Grid>
			<Grid item xs={4} data-tour-id="cond-pch-comp-unit">
				<AlertsComparatorUnit/>
			</Grid>
			<Grid item xs={12} data-tour-id="cond-pch-comp-type">
				<AlertsComparisonType/>
			</Grid>
			<Grid item xs={12}>
				<Divider sx={{ my: 1 }}/>
			</Grid>
			<Grid item xs={12} data-tour-id="cond-pch-more">
				<AlertsMoreFeatures/>
			</Grid>
		</Grid>}
	/>
}